import { Box } from "@vinomofo/components";

import { ContentBlock } from "../../component-factory/content-block";
import { BannerProps } from "../banner";
import { VideoHero } from "../video-hero/VideoHero";
import { getAssetType } from "../../utils/media-helpers";

export const BannerHero = ({
  banner,
}: {
  banner: BannerProps;
}): JSX.Element => {
  if (banner.__typename === "VinoData_VideoBlock") {
    if (getAssetType(banner.url || "") === "video") {
      return (
        <VideoHero url={banner.url} imageBackground={banner?.imageBackground} />
      );
    } else {
      return <></>;
    }
  }

  return (
    <Box display="flex" width="100%" height={["420px", "600px", "600px"]}>
      <ContentBlock {...banner} hero />
    </Box>
  );
};
